import React from 'react';
import { useCurrentUser } from '../../../../utils/CurrentUserContext';
import { useFormContext } from 'react-hook-form';
import SwitchField from './SwitchField';
import { isNativeDisplayCampaign } from '../../../../utils/api/campaign';

const DisableSEOField = () => {
  const {isAgencyOrAdvertiser} = useCurrentUser()
  const {watch} = useFormContext()
  const campaignType = watch('type')

  return (
    <SwitchField
      name='disableSEO'
      label='Disable SEO'
      hidden={isAgencyOrAdvertiser || isNativeDisplayCampaign(campaignType)}
    />
  );
};

export default DisableSEOField;

